var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "240.000000pt",
    height: "240.000000pt",
    viewBox: "0 0 240.000000 240.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,240.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M988 1980 c-121 -25 -208 -55 -312 -107 -227 -113 -454 -312 -622 -545 l-57 -79 19 -35 c40 -74 184 -255 294 -368 273 -281 554 -429 841 -443 302 -15 572 89 842 323 128 111 298 322 387 480 l23 40 -41 61 c-247 364 -604 615 -966 678 -119 20 -298 18 -408 -5z m315 -295 c253 -53 427 -302 388 -555 -41 -271 -295 -462 -561 -421 -217 33 -388 204 -421 421 -38 251 134 501 384 555 81 18 128 18 210 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096 1484 c-69 -22 -156 -110 -179 -183 -22 -68 -22 -134 0 -202 24 -75 107 -158 182 -182 119 -38 226 -13 311 73 41 40 60 69 73 109 38 119 13 226 -73 311 -84 85 -194 111 -314 74z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7f6292d92f014247b155b06e28132b01.svg";
export { ForwardRef as ReactComponent };